import { useEffect } from 'react'
import { usePostHog } from '@posthog/react'
import { useUser, useClientOptions } from '@paintscout/ui-business'
import * as Sentry from '@sentry/react'
import { initAnalytics, track } from 'shared/util/analytics'

export default function PostHogIdentify(): JSX.Element {
  const posthog = usePostHog()
  const { options } = useClientOptions()
  const { user, isPainter, highestRole, painterType } = useUser()

  useEffect(() => {
    if (!posthog || !user?.user_id || !options) return
    if (!process.env.POSTHOG_PROJECT_TOKEN) return
    if (process.env.DEPLOYMENT_STAGE === 'master' && !isPainter) return

    const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
    const standalone = 'standalone' in window.navigator && (window.navigator as any).standalone

    posthog.identify(user.user_id, {
      name: user.name,
      email: user.email,
      companyId: user.app_metadata.companyId,
      company: options.options.companyName.value,
      iPadOS,
      standalone,
      role: highestRole ?? null,
      painterType: painterType ?? null
    })

    posthog.group('company', user.app_metadata.companyId, {
      name: options.options.companyName.value
    })

    initAnalytics()
    track('user_logged_in')

    const sessionReplayUrl = posthog.get_session_replay_url()
    if (sessionReplayUrl) {
      Sentry.configureScope((scope) => {
        scope.setExtra('postHogSessionURL', sessionReplayUrl)
      })
    }
  }, [posthog, options, user?.user_id, isPainter, highestRole, painterType])

  return null
}
